import styled from 'styled-components'
import { belowContainer } from 'utilities/styled'
import { svgStroke } from 'utilities/styled'
import { H3 } from 'components/typography/heading'
import { ChevronDown, ArrowRight as ArrowRightBase } from 'styled-icons/feather'

export const containerProps = {
    name: 'integration',
    breakpoint: 750
}

export const IntegrationItem = styled.details`
    container-type: inline-size;
    container-name: ${containerProps.name};

    border-bottom: 1px solid var(--huma-color-border-default);
`

export const Header = styled.summary`
    cursor: pointer;

    display: grid;
    grid-template-columns: 40px 1fr 1fr 24px;
    align-items: center;
    justify-items: start;
    column-gap: 16px;

    width: 100%;
    padding-block: 20px;

    &:where(:hover, :focus-visible) {
        text-decoration: none;
    }

    &::-webkit-details-marker {
        display: none;
    }
`

export const Heading = styled(H3)`
    ${Header}:where(:hover, :focus-visible) & {
        text-decoration: underline;
    }
`

export const ToggleArrow = styled(ChevronDown)`
    ${svgStroke()}

    transition: rotate .15s;

    ${IntegrationItem}[open] & {
        rotate: 0.5turn;
    }
`

export const ArrowRight = styled(ArrowRightBase)`
    ${svgStroke()}

    transition: transform .1s ease-in-out;

    ${Header}:where(:hover, :focus-visible) & {
        transform: translateX(4px);
    }
`

export const Content = styled.div`
    padding: 20px 56px;

    ${belowContainer(containerProps)`
        padding-inline: 0;
    `}
`